import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CURRENCIES } from "../consts";
import { CREATE_CUSTOMER } from "./graphql";
import OdooCustomerTagsView from "./OdooCustomerTagsView";

const NewCustomerForm = () => {
  const [name, setName] = useState("");
  const [system, setSystem] = useState("AB");
  const [currency, setCurrency] = useState("USD");
  const [tags, setTags] = useState([]);
  const [syncToOdoo, setSyncToOdoo] = useState(true);

  const navigate = useNavigate();

  const [create, createRes] = useMutation(CREATE_CUSTOMER, {
    onCompleted(res) {
      navigate(`/sales/customers/${res.salesCreateCustomer.customer.id}`);
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["SALES_FETCH_CUSTOMERS"],
  });

  function createHandler() {
    const trimmedName = name.trim();
    if (!trimmedName) {
      window.alert("Please enter a name for the customer.");
      return;
    }

    create({
      variables: {
        name: trimmedName,
        system,
        currency,
        syncToOdoo,
        tags,
      },
    });
  }

  return (
    <div className="text-sm">
      <div className="-mx-2">
        <table className=" whitespace-nowrap">
          <tbody>
            <tr>
              <td>
                <label>Name</label>:
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Company</label>:
              </td>
              <td>
                <Select
                  value={system}
                  onChange={(e) => setSystem(e.target.value)}
                >
                  <option value="AB">Waboba AB</option>
                  <option value="LTD">Waboba LTD</option>
                </Select>
              </td>
            </tr>
            <tr>
              <td className="align-baseline">
                <label className="text-purple-700 dark:text-purple-800">
                  Odoo
                </label>
                :
              </td>
              <td className="align-baseline">
                <div>
                  <input
                    id="syncToOdoo"
                    type="checkbox"
                    checked={syncToOdoo}
                    onChange={(e) => setSyncToOdoo(e.target.checked)}
                  />
                  <label
                    htmlFor="syncToOdoo"
                    className="pl-2 font-normal whitespace-normal"
                  >
                    Create a new customer in Odoo at the same time.
                  </label>
                </div>
                <div className="text-xs opacity-70">
                  You can always connect to an existing Odoo customer later.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {syncToOdoo && (
        <div className="mt-6">
          <h5>Odoo Customer Info</h5>
          <div className="-mx-2 mt-2">
            <table>
              <tbody>
                <tr>
                  <td className="align-baseline">
                    <label>Currency</label>:
                  </td>
                  <td className="align-baseline">
                    <div className="flex items-center space-x-2">
                      <Select
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                      >
                        {CURRENCIES.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </Select>
                      <div className="text-xs opacity-70">
                        Required in Odoo. If you need another currency, please
                        contact IT support.
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <label>Tags</label>:
                  </td>
                  <td>
                    <OdooCustomerTagsView value={tags} onChange={setTags} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      <hr />

      <div className="mt-4">
        <Button primary onClick={createHandler} loading={createRes.loading}>
          Create
        </Button>
      </div>
    </div>
  );
};

export default NewCustomerForm;
